import { useTranslation } from 'react-i18next';
import { useServiceRequestContext } from '../../context/ServiceContext';
import { StyledAddServiceCase } from './AddServiceCase.styles';
import { IdentifyDevice } from './components/IdentifyDevice/IdentifyDevice';
import { ServiceSteps } from './components/ServiceSteps/ServiceSteps';
import { IssueDescription } from './components/IssueDescription/IssueDescription';
import { IssueDetails } from './components/IssueDetails/IssueDetails';
import { ReviewSubmit } from './components/ReviewSubmit/ReviewSubmit';
import { RequestSubmitted } from './components/RequestSubmitted/RequestSubmitted';

export const AddServiceCase = (): JSX.Element => {
  const { t } = useTranslation();
  const { currentAddServiceCaseStep, isServiceRequestSubmitted } = useServiceRequestContext();

  return (
    <StyledAddServiceCase className="add-service-case">
      <div className="add-service-case__header">
        <h1 className="add-service-case__title">{t('service.title')}</h1>
      </div>

      <div className={`add-service-case__body ${isServiceRequestSubmitted ? 'add-service-case__body--submitted' : ''}`}>
        {isServiceRequestSubmitted ? (
          <RequestSubmitted />
        ) : (
          <>
            <ServiceSteps currentStep={currentAddServiceCaseStep} />
            <div className="add-service-case__content">
              {currentAddServiceCaseStep === 0 && <IdentifyDevice />}
              {currentAddServiceCaseStep === 1 && <IssueDescription />}
              {currentAddServiceCaseStep === 2 && <IssueDetails />}
              {currentAddServiceCaseStep === 3 && <ReviewSubmit />}
            </div>
          </>
        )}
      </div>
    </StyledAddServiceCase>
  );
};
